interface Window {
  YT?: typeof YT;
  onYouTubeIframeAPIReady?: () => void;
}

declare const window: Window;

export function loadYouTubeAPI(): Promise<void> {
  // If the API is already loaded, resolve immediately
  if (window.YT) return Promise.resolve();
  
  return new Promise((resolve) => {
    // Create script element
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    
    // Add script to page
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

    // Set callback for when API is ready
    window.onYouTubeIframeAPIReady = () => {
      resolve();
    };
  });
}
